































































import { Component, Vue } from 'vue-property-decorator';
import confirmFeedback from '@/components/common/confirmFeedback.vue';
import { Dialog } from 'vant';
import * as api from '@/api';
import UserModule from '@/store/modules/user';
import { guid } from '@/utils/util';
import axios from 'axios';
@Component({ components: { confirmFeedback } })
export default class extends Vue {
  isDisabled: boolean = false;
  loading: boolean = false;
  finished: boolean = false;
  errorMsg: string = '';
  feedbackShow: boolean = false;
  feedbackType: string = '';
  successStatu: boolean = false;
  classList: any = ['培训班1', '培训班2', '培训班3'];
  className: string = '';
  classItem: any = {};
  form: {
    id: string;
    classId: string;
    className: string;
    description: string;
    classType: number;
    attachmentKey: string;
  } = {
    id: '',
    classId: '',
    className: '',
    description: '',
    classType: 1,
    attachmentKey: '',
  };
  enclosure: string = ''; // 附件名称

  mounted() {
    window.addEventListener('pagehide', this.onPageUnload);
    if (this.$route.query.classItem) {
      this.classItem = JSON.parse(this.$route.query.classItem as any);
      const type = this.$route.query.type;
      if (type == '已提交') {
        this.form.id = this.classItem.id;
        this.form.classId = this.classItem.publicTrainingClassId;
        this.form.classType = this.classItem.classType;
        this.form.description = this.classItem.description;
        this.form.attachmentKey = this.classItem.attachmentKey;
      }
      if (type == '未提交') {
        this.form.classId = this.classItem.id;
        this.form.classType = this.classItem.trainingClassType;
        // this.form.attachmentKey = guid();
      }
      this.form.className = this.classItem.className;
      if (this.form.attachmentKey) this.getAttachmens('心得附件', this.form.attachmentKey);
    }
  }
  //页面刷新
  onPageUnload() {
    sessionStorage.setItem('expClassName', JSON.stringify(this.className));
    sessionStorage.setItem('expSolutionId', JSON.stringify(this.form.classId));
    sessionStorage.setItem('classType', JSON.stringify(this.form.classType));
  }

  beforeUpload(file: any) {
    if (file.type !== 'image/jpeg') {
      Dialog.alert({
        message: '请上传 jpg 格式图片',
      });
      return false;
    }
    return true;
  }

  async afterUpload(file: any) {
    this.enclosure = file.file.name;
    this.form.attachmentKey = guid();
    await this.uploadFile(file, this.form.attachmentKey);
  }

  async uploadFile(file: any, key: string) {
    let formData = new FormData();
    formData.append('file', file.file);
    formData.append('StringKey1', key);
    formData.append('Category', '心得附件');
    try {
      await apiAxios
        .post('/api/NewAttachment/Upload', formData, axiosOptions)
        .then(res => {
          this.enclosure = file.file.name;
        })
        .catch(err => {});
    } catch (err) {
      Dialog.alert({
        message: '上传失败',
      });
    }
  }

  async getAttachmens(keyName: string, key: string) {
    const { data } = await apiAxios.get('/api/NewAttachment/GetAttachmens', {
      params: {
        StringKey1: key,
        Category: keyName,
      },
    });
    this.enclosure = data[0].displayName;
  }

  async onSubmit() {
    if (this.form.description) {
      this.feedbackShow = true;
      //系统返回提交状态
      try {
        const { data, success, message } = await api.Experience.save_POST(this.form);
        if (success) {
          this.successStatu = true;
          //提交成功，清空form
          for (let k of Object.keys(this.form)) {
            Vue.delete(this.form, k);
          }
          this.$router.go(-1);
        } else {
          this.successStatu = false;
          this.errorMsg = message;
        }
      } finally {
        this.loading = false;
        this.finished = true;
      }
      this.feedbackType = '心得';
    } else {
      Dialog.alert({
        title: '',
        message: '请先填写您的上课心得',
      });
    }
  }

  //关闭提交状态对话框回调事件
  feedbaclCancle() {
    this.feedbackShow = false;
  }
}

const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);

export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
